<div
  class="px-2 min-h-full flex items-center rounded-2xl py-4 bg-greyBg shadow-[0px 4px 20px 0px rgba(234, 234, 234, 0.16)]"
>
  <div class="justify-center flex items-center rounded-xl bg-white p-2">
    @if(icon){

      <i class="{{ icon }} {{ color }} text-lg" ></i>
    }
    @if(img){
      <img [src]="img" class="w-[24px]">
    }
  </div>
  <div class="ms-2">
    <p class="lg:text-[10px] md:text-base  text-gray-600">{{ label }}</p>
    <p class="lg:text-base	 md:text-lg font-bold">{{ count }}</p>
  </div>
</div>
